import { useCallback } from 'react';
import { AssistantFilesService } from '../services/AssistantFilesService';

type AssistantFilesParams = {
  getUserToken: () => string | undefined | Promise<string | undefined>;
};

export const useAssistantFiles = (params: AssistantFilesParams) => {
  const listFilesForAssistant = useCallback(async (assistantInternalName: string | null, subfolder: string | null) => {
    const token = await params.getUserToken();
    return AssistantFilesService.listFiles(token as string, assistantInternalName, subfolder);
  }, [params]);

  const embedFileForAssistant = useCallback(async (assistantInternalName: string | null, item: any) => {
    if (!item.fileUrl) throw new Error('Keine fileUrl vorhanden.');
    const token = await params.getUserToken();
    return AssistantFilesService.embedFile(token as string, assistantInternalName, item.fileUrl);
  }, [params]);

  const deleteFileForAssistant = useCallback(async (assistantInternalName: string | null, item: any) => {
    if (!item.fileUrl) throw new Error('Keine fileUrl vorhanden.');
    const token = await params.getUserToken();
    await AssistantFilesService.deleteFile(token as string, assistantInternalName, item.fileUrl);
  }, [params]);

  const renameFolderForAssistant = useCallback(async (assistantInternalName: string | null, sourcePath: string, targetPath: string) => {
    const token = await params.getUserToken();
    await AssistantFilesService.renameFolder(token as string, assistantInternalName, sourcePath, targetPath);
  }, [params]);

  const deleteFolderForAssistant = useCallback(async (assistantInternalName: string | null, folderPath: string) => {
    const token = await params.getUserToken();
    await AssistantFilesService.deleteFolder(token as string, assistantInternalName, folderPath);
  }, [params]);

  const uploadFilesToFolderForAssistant = useCallback(async (assistantInternalName: string | null, subfolder: string | null, files: File[]) => {
    if (!files.length) return [];
    const token = await params.getUserToken();
    return AssistantFilesService.uploadFiles(token as string, assistantInternalName, subfolder, files);
  }, [params]);

  return {
    listFilesForAssistant,
    embedFileForAssistant,
    deleteFileForAssistant,
    renameFolderForAssistant,
    deleteFolderForAssistant,
    uploadFilesToFolderForAssistant,
  };
};
